import { Attrs, Minze, MinzeElement } from 'minze'
import axios from 'redaxios'
import { config } from '../../constants'

export interface LvcArtistSpectacles {
  loading: boolean
  dataPageId: string
}

export class LvcArtistSpectacles extends MinzeElement {
  attrs: Attrs = [['data-page-id']]
  loading = true
  async fetchEventsForArtist() {
    try {
      const result = await axios.get(
        `${config.backendApi}/content/getArtistEvents?id=${this.dataPageId}`
      )
      if (!result.data) return null
      return result.data
    } catch (err) {
      return null
    }
  }

  onReady = async () => {
    const data = await this.fetchEventsForArtist()
    Minze.cast('lvc:artist-spectacles-events-loaded', {
      events: data,
    })
    this.loading = false
    this.rerender()
  }

  html = () => {
    return /*html*/ `
      <div>
        <lvc-artist-events loading=${this.loading}></lvc-artist-events>
        <lvc-artist-event-offers loading=${this.loading}></lvc-artist-event-offers>
      </div>
    `
  }
}
